class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.headerArrowToggle = this.querySelector('details').querySelector('.icon-caret-two');
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.headerArrowToggle.addEventListener('focus', this.onFocus.bind(this));
  }

  onFocus() {
    this.headerArrowToggle.addEventListener('keydown',function(e){
      if (e.key == 'Enter') {
        setTimeout(()=>{
          if(this.closest('details').hasAttribute("open")){
            this.setAttribute('aria-label', 'Submenu expanded');
          }else {
            this.setAttribute('aria-label', 'Submenu collapsed');
          }
        },400);
      }
      if (e.keyCode === 27) {
        this.setAttribute('aria-label', 'Submenu collapsed');
      }
    })
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// Close header submenu details on click
$(function () {
  const details = document.querySelectorAll(".header__submenu details");
  details.forEach((targetDetail) => {
    targetDetail.addEventListener("click", () => {
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.removeAttribute("open");
        }
      });
    });
  });
});


